module.exports = __webpack_public_path__ + "img/locblock.eb5c837b.svg";